import axios from 'axios';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { baseUrlMapper, apiKeyMapper } from './const';
import {
  getBaseParams,
  safeGet,
  getPageLoadTime,
} from './utils';

const apiInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    apiKey: apiKeyMapper[process.env.NODE_ENV],
  },
});

class DeviceFingerprintManager {
  /**
   * 获取设备指纹
   * @returns {Promise<string>} 设备指纹
   * @author Nemo
   */
  async getDeviceFingerprint() {
    try {
      // 获取FingerprintJS实例
      const fp = await FingerprintJS.load();
      // 获取访客标识符
      const result = await fp.get();
      return result.visitorId;
    } catch (error) {
      console.error('获取设备指纹失败:', error);
      return null;
    }
  }

  // 发送埋点
  async send(params) {
    try {
      // 获取设备指纹
      const deviceFingerprint = await this.getDeviceFingerprint();
      
      // 字段名解释：https://confluence.ronhan.com/confluence/pages/viewpage.action?pageId=43035843
      const param = {
        ...params,
        ...getBaseParams(),
        plt: safeGet(() => getPageLoadTime()),
        d: deviceFingerprint, // 设备指纹
      };

      try {
        apiInstance.post(baseUrlMapper[process.env.NODE_ENV] + '/risk-engine/ec/ckt/v1/ublog', param);
      } catch (error) {

      }
    } catch (error) {

    }
  }
}

const deviceFingerprintManager = new DeviceFingerprintManager();

export { deviceFingerprintManager };
